export default __webpack_public_path__ + "static/media/PredefinidaSinGse.1b5ffd9a.png";